import Service from '@ember/service';

import { service } from '@ember/service';

export default class AnnouncementsService extends Service {
  @service store;

  modelName = 'announcement';

  fetch(cacheKey = undefined) {
    const { modelName } = this;
    const query = {
      'page[limit]': 50,
      sort: '-field_announcement_date',
      // 'sort[sort-date][path]': 'field_announcement_date',
      // 'sort[sort-date][direction]': 'DESC',
    };
    if (this.store.isDestroyed) {
      return Promise.reject();
    }
    return cacheKey ? this.store.queryWithCache(cacheKey, modelName, query)
      : this.store.query(modelName, query);
  }
}
